import type { fabric } from 'fabric';
import type { FabricEditor } from 'modules/fabric-editor';
import { useCallback, useEffect, useState } from 'react';

export function useFabricData<T>(
  object: fabric.Object,
  key: string,
  editor: FabricEditor,
): [T | undefined, (value: T | undefined) => void] {
  const read = useCallback(
    () => (object.data as Record<string, T> | undefined)?.[key],
    [object, key],
  );
  const [value, setValue] = useState<T | undefined>(read);

  useEffect(() => {
    setValue(read());
    const off = editor.on('object:modified', (e) => {
      if (e.target === object) setValue(read());
    });
    return () => off();
  }, [editor, object, read]);

  const update = useCallback(
    (next: T | undefined) => {
      editor.objects.setData(object, key, next);
      setValue(next);
    },
    [editor, object, key],
  );

  return [value, update];
}
